module.exports = __webpack_public_path__ + "static/media/spotify-logo.c4d35f7b.png";